module.exports = __webpack_public_path__ + "static/media/wallet-card.73ee7e94.svg";